/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TouchpointVersionFeedbackRequestType =
  (typeof TouchpointVersionFeedbackRequestType)[keyof typeof TouchpointVersionFeedbackRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TouchpointVersionFeedbackRequestType = {
  POSITIVE: "POSITIVE",
  NEGATIVE: "NEGATIVE",
} as const;
